/**
 * SaaS URL configuration for Negócio Fácil
 * Primary domain: https://usenegociofacil.com.br
 * SaaS app: https://app.usenegociofacil.com.br
 */

export const SAAS_URL = 'https://app.usenegociofacil.com.br';
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://negociofac5628.builtwithrocket.new';

/** Redirect to SaaS signup (starts 14-day free trial) */
export const SAAS_SIGNUP_URL = SAAS_URL;

/** Redirect to SaaS login */
export const SAAS_LOGIN_URL = SAAS_URL;

/** Redirect to SaaS dashboard (for authenticated users) */
export const SAAS_DASHBOARD_URL = SAAS_URL;

/** Redirect to SaaS subscription management */
export const SAAS_SUBSCRIPTION_URL = SAAS_URL;

/** Checkout URLs for specific plans */
export const SAAS_CHECKOUT_BASIC_URL = SAAS_URL;
export const SAAS_CHECKOUT_PRO_URL = SAAS_URL;

/**
 * Get the primary CTA URL — always points to SaaS
 */
export function getTrialUrl(_source?: string): string {
  return SAAS_URL;
}

const SAAS_DEMO_URL: any = null;

export { SAAS_DEMO_URL };